<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="https://www.tamep.bo/">TRANSPORTE AEREO MILITAR</a>
          </li>
          <li>
            <a href="https://ciaceduca2025.tamep.bo/login/index.php"> CIAC </a>
          </li>
          <li>
            <a href="https://sisecc.tamep.bo/"> SISECC</a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
